<template>
  <div class="">
    <h2 class="text-xl text-gray-800 font-bold pt-6">Subscription and Payment Information</h2>
    <p class="text-gray-800 mb-4">You are signing up to receive text messages from {{baker.name}}.</p>
    <div class="text-md text-gray-800 border-teal-400 border bg-teal-50 p-4 mb-4" v-if="baker.subscription_form === 'gather'">
      <p class="mb-4"><strong>This project is in Gather mode.</strong> Once {{ baker.name }} gathers their first three subscribers, this project will become active and your subscription will begin. By subscribing now, you are showing your support and will receive baking notifications from {{ baker.name }} once their project becomes active.</p>
      <p>Your payment card will not be charged until this project becomes active.</p>
    </div>
    <div class="bg-white p-8 text-center shadow-md my-4 sm:mx-16 border-t-4 border-yellow-400">
      <div class="text-4xl text-teal-700 font-black mb-1">Free<span v-if="subscriptionCosts.specialNotice">*</span></div>
      <p v-if="subscriptionCosts.specialNotice" class="text-gray-800 text-md mb-4">*{{subscriptionCosts.specialNotice}}</p>
      <p class="text-gray-800">Access to baking notifications from {{ baker.name }}</p>
    </div>
  </div>
</template>
<script>
  export default {
    name: "PaymentProcessorNone",
    components: {},
    props: {
      baker: {
        type: Object,
        default() {
          return {};
        }
      },
      isSquareLoaded: {
        type: Boolean,
        default: false,
      },
      subscriptionCosts: {
        type: Object,
        default() {
          return {
            original: 10,
            currentCharge: 10,
            promoCodePrice: 0,
            specialNotice: null,
          }
        }
      }
    },
    data() {
      return {
        formData: {
          billing_address: {

          },
          billing_address_same_as_address: true,
        },
        promo_code_message: null,
        promo_code_used_code: null,
      }
    },
    methods: {}
  }
</script>
